import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, useTheme } from '@mui/material';

import { SubmitButton } from 'components';
import { SupervisorSuspendServiceForm } from 'forms';
import { SuspendServicePageContext, SuspendServicePageContextProvider } from './suspend-service-page.context';
import { ROUTES } from 'consts';

export const SuspendServicePage = () => {
  const theme = useTheme();
  const formRef = useRef<any>();
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 320 }}>
      <SuspendServicePageContextProvider>
        <SuspendServicePageContext.Consumer>
          {({ zoneName, buildingName, orgSlug, buildingId, scheduleId, userId }) => (
            <Box
              sx={{ width: '100%', maxWidth: theme.breakpoints.values.sm, margin: 'auto', paddingX: 3, paddingY: 6 }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box>
                    <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
                      Would you like to suspend the scheduled service for{' '}
                      <Typography
                        component="span"
                        sx={{ color: theme.palette.primary.main, fontSize: 18, fontWeight: 600 }}
                      >
                        premier zone {zoneName}?
                      </Typography>
                    </Typography>

                    <Typography color="textSecondary" sx={{ fontSize: 12, marginTop: 0.5 }}>
                      Suspending the zone will temporarily turn off the premier zone schedule for the remainder of the
                      day. Premier zone schedule will resume the following business day. Team members are encouraged to
                      service zones regardless of suspension of premier zone(s). Comments collected will be included in
                      the{' '}
                      <Typography
                        component="span"
                        variant="subtitle2"
                        sx={{ color: theme.palette.primary.main, fontSize: 12, fontStyle: 'italic', fontWeight: 600 }}
                      >
                        service zone report
                      </Typography>
                      . To disable a premier zone indefinitely please visit the zone section.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <SupervisorSuspendServiceForm
                    ref={formRef}
                    zoneName={zoneName}
                    buildingName={buildingName}
                    orgSlug={orgSlug}
                    buildingId={buildingId}
                    scheduleId={scheduleId}
                    userId={userId}
                    onSubmitting={(loading) => setLoadingSubmit(loading)}
                    next={() => navigate(`/${ROUTES.SUPERVISOR}/${ROUTES.SUSPEND_SERVICE_SUCCESS}`, { replace: true })}
                  />
                </Grid>

                <Grid item xs={12}>
                  <SubmitButton
                    loading={loadingSubmit}
                    label={'Submit Entry'}
                    onClick={() => formRef.current.onSubmit()}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </SuspendServicePageContext.Consumer>
      </SuspendServicePageContextProvider>
    </Box>
  );
};
